import { motion } from "framer-motion";
import { Scissors } from "lucide-react";
import { SPECIALS } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";

const Ticket = ({ s, i, onUse }) => (
  <Reveal delay={i * 0.08} className="flex">
    <motion.div whileHover={{ y: -6, rotate: i === 1 ? 0 : i === 0 ? -1 : 1 }} transition={{ type: "spring", stiffness: 260, damping: 20 }}
      className={`relative flex w-full flex-col rounded-[1.6rem] p-7 ${i === 0 ? "bg-amber-400 text-[#0B0F17]" : "border border-white/10 bg-[#161F30] text-white"}`} data-testid={`special-${s.code.toLowerCase()}`}>
      <span className={`absolute -left-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full ${i === 0 ? "bg-[#0B0F17]" : "border-r border-white/10 bg-[#0B0F17]"}`} />
      <span className={`absolute -right-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full ${i === 0 ? "bg-[#0B0F17]" : "border-l border-white/10 bg-[#0B0F17]"}`} />
      <p className={`font-mono-x text-xs uppercase tracking-[0.2em] ${i === 0 ? "text-[#0B0F17]/70" : "text-amber-300"}`}>{s.title}</p>
      <p className="mt-3 font-display text-7xl font-extrabold leading-none tracking-tight">{s.percent}<span className="text-4xl">% off</span></p>
      <p className={`mt-4 flex-1 text-sm ${i === 0 ? "text-[#0B0F17]/80" : "text-slate-300"}`}>{s.text}</p>
      <div className={`mt-6 flex items-center justify-between gap-3 border-t border-dashed pt-5 ${i === 0 ? "border-[#0B0F17]/30" : "border-white/20"}`}>
        <span className="inline-flex items-center gap-2 font-mono-x text-sm font-medium tracking-wider"><Scissors className="h-4 w-4" /> {s.code}</span>
        <button onClick={() => onUse(s.code)} data-testid={`special-use-${s.code.toLowerCase()}`}
          className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${i === 0 ? "bg-[#0B0F17] text-amber-300 hover:bg-black" : "bg-white/10 hover:bg-amber-400 hover:text-[#0B0F17]"}`}>
          Use code
        </button>
      </div>
    </motion.div>
  </Reveal>
);

export const Specials = ({ onUse }) => (
  <section id="specials" className="relative mx-auto max-w-7xl px-5 pt-24 sm:px-8 lg:pt-36" data-testid="specials-section">
    <div className="mb-12 grid gap-6 lg:grid-cols-12 lg:items-end">
      <Reveal className="lg:col-span-7">
        <Eyebrow>Specials</Eyebrow>
        <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1] tracking-tight text-white sm:text-5xl lg:text-6xl">
          Brilliance, <span className="text-outline">for less.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-5">
        <p className="text-base text-slate-300 md:text-lg">Tap “Use code” and it's added to your booking. One code per booking.</p>
      </Reveal>
    </div>
    <div className="grid gap-5 md:grid-cols-3">
      {SPECIALS.map((s, i) => <Ticket key={s.code} s={s} i={i} onUse={onUse} />)}
    </div>
  </section>
);
